<div class="container-fluid">
  <!-- <ngx-loading [show]="pageload"></ngx-loading> -->
  <div class="col-12" *ngIf="pageload">
    <app-busy [message]="message"></app-busy>
  </div>
  <div class="row">
    <div style="margin-top:10px; margin-bottom:-10px;">
      <h4>
        <span style="padding-right:15px"></span>
        <i class="fa fa-cogs"></i>
        <b> Permit:</b> New Application <span style="color:lightgray">( {{dataCntrl.carrier.name}} )</span>
      </h4>
    </div>
  </div>
  <hr>
  <div class="card">
    <div class="card-data">
      <div class="col-md-12">
        <div class="row">
          <div class="col-sm-2">
            <label><strong>Account Balance</strong></label>
            <input class="form-control-plaintext" type="text" [ngModel]="dataCntrl.carrier.account_balance"
             readonly />
          </div>
          <div class="col-sm-8">
            <label><strong>Permit Type</strong></label>
            <input class="form-control-plaintext" type="text" [ngModel]="dataCntrl.selectedtype"
             readonly />
          </div>
          <div class="col-sm-2">
            <label><strong>My App Reference</strong></label>
            <input class="form-control" type="text" [(ngModel)]="dataCntrl.application.reference_num"
             />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-data">
      <br>
      <div class="col-md-12">
        <nav>
          <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
            <a class="nav-item nav-link active" id="nav-permitype-tab" data-toggle="tab" href="#nav-permitype" role="tab"
              (click)="tabChanged('permitype')" [ngStyle]="{'color': StartComplete && 'green'}"
              [ngClass]="{ 'active':activeTab==='permitype'}" aria-controls="nav-permitype" aria-selected="true">Permit Type</a>
            <a class="nav-item nav-link" id="nav-vehicle-tab" data-toggle="tab" href="#nav-vehicle" role="tab"
              (click)="tabChanged('vehicle')" [ngStyle]="{'color': VehicleComplete && 'green'}"
              [ngClass]="{ 'active':activeTab==='vehicle'}" aria-controls="nav-vehicle"
              aria-selected="false">Vehicles</a>
            <a class="nav-item nav-link" id="nav-route-tab" data-toggle="tab" href="#nav-route" role="tab"
              (click)="tabChanged('route')" [ngClass]="{ 'active':activeTab==='route'}"
              aria-controls="nav-route" aria-selected="false">Route</a>
            <a class="nav-item nav-link" id="nav-motivation-tab" data-toggle="tab" href="#nav-motivation" role="tab"
              (click)="tabChanged('motivation')"
              [ngClass]="{ 'active':activeTab==='motivation'}"
              aria-controls="nav-motivation" aria-selected="false">Motivation</a>
            <a class="nav-item nav-link" id="nav-uploads-tab" data-toggle="tab" href="#nav-uploads" role="tab"
              (click)="tabChanged('uploads')"
              [ngClass]="{ 'active':activeTab==='uploads'}" aria-controls="nav-uploads"
              aria-selected="false">Uploads</a>
          </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
            <ngx-loading [show]="tabload"></ngx-loading>
          <div class="tab-pane fade show active" id="nav-permitype" role="tabpanel" aria-labelledby="nav-permitype-tab" [ngClass]="{ 'show active':activeTab==='permitype'}">
            <app-app-permit-type [(dataCntrl)]="dataCntrl"></app-app-permit-type>
          </div>
          <div class="tab-pane fade" id="nav-vehicle" role="tabpanel" aria-labelledby="nav-vehicle-tab" [ngClass]="{ 'show active':activeTab==='vehicle'}">
            <app-app-vehicle [(dataCntrl)]="dataCntrl"></app-app-vehicle>
          </div>
          <div class="tab-pane fade" id="nav-route" role="tabpanel" aria-labelledby="nav-route-tab" [ngClass]="{ 'show active':activeTab==='route'}">
            <app-app-route [(dataCntrl)]="dataCntrl"></app-app-route>
          </div>
          <div class="tab-pane fade" id="nav-motivation" role="tabpanel" aria-labelledby="nav-motivation-tab" [ngClass]="{ 'show active':activeTab==='motivation'}">
            <app-app-motivation [(dataCntrl)]="dataCntrl"></app-app-motivation>
          </div>
          <div class="tab-pane fade" id="nav-uploads" role="tabpanel" aria-labelledby="nav-uploads-tab" [ngClass]="{ 'show active':activeTab==='uploads'}">
            <app-app-uploads [(dataCntrl)]="dataCntrl"></app-app-uploads>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-data">
      <button title="Submit" type="submit" id="btnSubmit" *ngIf="canSubmit || editMode==true" (click)="onSubmit()"
        class="btn btn-md btn-info pull-right" style="margin-left:10px; ">
        <i class="fa fa-upload"></i> Submit</button>
      <button title="Cancel" type="button" id="btnCancel" (click)="onCancel()" class="btn btn-md btn-primary pull-right"
        style="margin-left:10px; ">
        <i class="fa fa-undo"></i> Cancel</button>
      <button title="Save Details" type="submit" id="btnSave" *ngIf="canSave || editMode==true" (click)="onSave()" [disabled]="!dataCntrl.formValid"
        class="btn btn-md btn-success pull-right" style="margin-left:10px; ">
        <i class="fa fa-save"></i> Save</button>
      <button title="Start Application" type="button" id="btnStart" *ngIf="!dataCntrl.processStarted || editMode==true"
        [disabled]="dataCntrl.permittypeSelected===false" (click)="onStart()" class="btn btn-md btn-success pull-right"
        style="margin-left:10px; ">
        <i class="fa fa-play"></i> Start</button>
    </div>
  </div>
</div>
